import React, { useEffect, useState } from 'react';
import { NumberPaginationProps } from './types';

const Width = 2;

const NumberPagination: React.FC<NumberPaginationProps> = (props) => {
  const [active, setActive] = useState<number>(0);

  /**
   * @description 設定當前頁碼
   */
  useEffect(() => {
    if (props.activeIndex !== active) {
      setActive(props.activeIndex);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.activeIndex]);

  /**
   * @description 處理頁碼 onClick 執行的事件
   * @param currentIndex 抽獎活動 index
   */
  const handleClick = (currentIndex: number) => {
    setActive(currentIndex);
    if (props.onPageClick) props.onPageClick(currentIndex);
  };

  return (
    <div className="numberPagination">
      {/* 前一頁按鈕 */}
      <button
        type="button"
        className="page-btn"
        disabled={active <= 0}
        onClick={() => {
          handleClick(active - 1);
        }}
        title="previous"
      >
        <img className="img" src={require('assets/images/chevron-left.png')} alt="previous" />
      </button>
      {/* 根據總數，生成頁碼 */}
      {Array(Width * 2 + 1)
        .fill(1)
        .map((_, pageIndex) => {
          let offset = 0;
          if (active - Width <= 0) {
            offset = Width - active;
          } else if (active > props.totalPage - Width - 1) {
            offset = props.totalPage - Width - active - 1;
          }
          const index = active - Width + pageIndex + offset;

          if (index < 0 || index >= props.totalPage) {
            return [];
          } else {
            return (
              <button
                className={'page-btn' + (active === index ? ' active' : '')}
                onClick={() => {
                  handleClick(index);
                }}
                key={index}
                title={`${index + 1}`}
              >
                {index + 1}
              </button>
            );
          }
        })}
      {/* 下一頁 */}
      <button
        type="button"
        className="page-btn"
        disabled={active + 1 >= props.totalPage}
        onClick={() => {
          handleClick(active + 1);
        }}
        title="next"
      >
        <img className="img" src={require('assets/images/chevron-right.png')} alt="next" />
      </button>
    </div>
  );
};

export default NumberPagination;
